"use client";

import { useState, useEffect } from "react";
import { Check, Mail, User } from "lucide-react";
import IMAGES from "../../constants/images";
import link from "../../assets/images/link.png";
import facebook from "../../assets/images/facebook.png";
import insta from "../../assets/images/insta.png";
import { loginWithOtp } from "../../redux/api/Auth/Login/otp";
import { sendOTP } from "../../redux/api/OTP/SendOtpSlice";
import { useDispatch, useSelector } from "react-redux";
import { MobileView } from "react-device-detect";
import { navigateTo, navigateToAdmin } from "../../utils/navigation";

export default function Component() {
  const dispatch = useDispatch();
  const { data, loading, error } = useSelector((state) => state.login);
  const [selectedRole, setSelectedRole] = useState("Practitioner");
  const [email, setEmail] = useState("");
  const [currentView, setCurrentView] = useState("login"); // "login" or "otp"
  const [otpCode, setOtpCode] = useState(["", "", "", "", "", ""]);
  const [countdown, setCountdown] = useState(90); // 1:30 in seconds
  const [bgImage, setBgImage] = useState(IMAGES.login_web);
  const [emailClassName, setEmailClassName] = useState(
    "block w-full pl-10 pr-3 py-3 border-1 border-[#CBD5E1] rounded-[12px] font-poppins text-[14px] text-[#171717] leading-5 bg-[#F8FAFC] placeholder-[#94A3B8] focus:outline-none focus:placeholder-[#334155] focus:ring-1 focus:ring-[#4B61FF] focus:border-[#4B61FF] mt-[20px] mb-[20px]"
  );
  const [emailError, setEmailError] = useState(null);
  const [otpError, setOTPError] = useState(null);
  const [links, setLinks] = useState([
    {
      id: 1,
      image: link,
      width: "24px",
      height: "24px",
      link: "https://www.linkedin.com/uas/login?session_redirect=%2Fcompany%2F100902149",
    },
    {
      id: 2,
      image: facebook,
      width: "24px",
      height: "24px",
      link: "https://www.facebook.com/phybercare",
    },
    {
      id: 3,
      image: insta,
      width: "24px",
      height: "24px",
      link: "https://www.instagram.com/phybercare/",
    },
  ]);
  // Auto-login when token is passed from admin app
  useEffect(() => {
    // Check for token in URL params (from admin app redirect)
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");

    if (token) {
      console.log("Token detected in URL, attempting auto-login...");

      // Store token and user role
      localStorage.setItem("token", token);
      localStorage.setItem("userRole", "COUNSELLOR");

      // Clear token from URL for security
      window.history.replaceState({}, document.title, window.location.pathname);

      // Redirect to dashboard
      console.log("Auto-login successful, redirecting to dashboard...");
      navigateTo("/dashboard");
    }
  }, []);

  useEffect(() => {
    const updateBg = () => {
      if (window.innerWidth >= 1024) {
        setBgImage(IMAGES.login_web);
      } else {
        setBgImage(IMAGES.login_mobile);
      }
    };

    updateBg(); // set on initial load
    window.addEventListener("resize", updateBg);
    return () => window.removeEventListener("resize", updateBg);
  }, []);

  useEffect(() => {
    let interval = null;
    if (currentView === "otp" && countdown > 0) {
      interval = setInterval(() => {
        setCountdown((countdown) => countdown - 1);
      }, 1000);
    } else if (countdown === 0) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [currentView, countdown]);

  const handleSendOTP = () => {
    if (email) {
      // setCurrentView("otp");
      // setCountdown(90);
      dispatch(sendOTP(email)).then((res) => {
        console.log("res=======>", res);
        if (res.payload.message.response_message === "Failure") {
          //  message.error(res.message.payload);
          // message.error("Hello");
          setEmailError(res.payload.message.payload);

          console.log(res.payload.message.payload);
        } else {
          if (res.payload.message.data.payload !== null) {
            setEmailError("");
            setCurrentView("otp");
            setCountdown(90);
          } else {
            setEmailError("User does not exists");
          }
        }
      });
    } else {
      setEmailClassName(
        "block w-full pl-10 pr-3 py-3 border-1 border-[#DC2626] rounded-[12px] font-poppins text-[14px] text-[#171717] leading-5 bg-[#F8FAFC] placeholder-[#94A3B8] focus:outline-none focus:placeholder-[#334155] focus:ring-1 focus:ring-[#4B61FF] focus:border-[#4B61FF] mt-[20px] mb-[20px]"
      );
      setEmailError("*Please proceed with organizational Email ID ");
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      // Handle the Enter key press
      handleSendOTP();
    }
  };

  const handleOTP = () => {
    console.log("otp", otpCode.join(""));
    let formData = {
      username: email,
      otp: otpCode.join(""),
      grant_type: "password",
    };
    dispatch(loginWithOtp(formData)).then((res) => {
      if (res.payload.status === "success") {
        let data = res.payload.message;
        console.log("data===>", data);
        localStorage.setItem("token", data.access_token);
        localStorage.setItem("userRole", "COUNSELLOR");
        navigateTo("/dashboard");
      } else {
        console.log("error", res.payload.message.error_description);
        setOTPError(res.payload.message.error_description);
      }
    });
  };

  const handleOtpChange = (index, value) => {
    if (value.length <= 1) {
      const newOtpCode = [...otpCode];
      newOtpCode[index] = value;
      setOtpCode(newOtpCode);

      // Auto-focus next input
      if (value && index < 5) {
        const nextInput = document.getElementById(`otp-${index + 1}`);
        if (nextInput) nextInput.focus();
      }
    }
  };

  const handleOtpKeyDown = (index, e) => {
    // Handle backspace to go to previous input
    if (e.key === "Backspace" && !otpCode[index] && index > 0) {
      const prevInput = document.getElementById(`otp-${index - 1}`);
      if (prevInput) prevInput.focus();
    } else if (e.key === "Enter") {
      if (otpCode.join("").length > 5) {
        handleOTP();
      }
    }
  };

  return (
    <div className="min-h-[calc(100vh/var(--app-zoom))] flex flex-col">
      {/* Mobile: Blue Section at Top, Desktop: Left Side */}
      <div
        className={`bg-cover bg-center
  lg:w-1/2 lg:h-[calc(100vh/var(--app-zoom))] lg:p-12 lg:fixed lg:left-0 lg:top-0`}
        style={{
          backgroundImage: `url(${bgImage})`,
        }}
      >
        <MobileView>
          <div
            className="w-full h-[200px]"
            style={{
              backgroundImage: `url(${IMAGES.login_mobile})`,
            }}
          ></div>
        </MobileView>
      </div>

      {/* Mobile: Form Section Below, Desktop: Right Side */}
      <div className="flex-1 lg:w-1/2 lg:ml-auto bg-gradient-to-br from-[#e6faf5] via-[#f0f9ff] to-[#e0e7ff] p-6 lg:p-12 flex flex-col justify-between min-h-[calc(100vh/var(--app-zoom))]">
        {/* Main Content */}
        <div className="flex-1 flex flex-col lg:justify-center">
          <div className="max-w-md mx-auto w-full">
            {/* Welcome Text */}
            <div className=" lg:text-left gap-0">
              <p className="text-[22px] font-poppins lg:text-[22px]  xl:text-[34px] font-600 font-semibold  text-[#171717] ">
                Welcome Back to
              </p>
              <p className="text-[22px] font-poppins lg:text-[22px] xl:text-[34px] text-transparent bg-clip-text bg-gradient-to-r from-[#2563EB] to-[#14B8A6] font-semibold -mt-[25px] lg:-mt-[40px]">
                Phybercare!
              </p>
            </div>

            {/* Form content (login or OTP) */}
            {currentView === "login" ? (
              <div className="space-y-6 lg:space-y-4 ">
                <h2 className="text-[16px] font-poppins lg:text-[22px] font-semibold text-[#171717]  lg:text-left">
                  Login to your account
                </h2>

                {/* Role Selection */}
                <div>
                  <p className="text-[14px] font-poppins text-[#334155] mb-3  lg:text-left">
                    As
                  </p>
                  <div className="flex flex-wrap gap-2 lg:gap-3  lg:justify-start">
                    {["Practitioner", "Admin"].map((role) => (
                      <button
                        key={role}
                        onClick={() => {
                          if (role === "Admin")
                            navigateToAdmin();
                        }}
                        className={`px-3 lg:px-4 py-2 rounded-[8px] font-poppins border-2 font-medium transition-all text-[12px] lg:text-[14px] ${
                          selectedRole === role
                            ? role === "Admin"
                              ? "bg-[#eaff6c] border-[#eaff6c] text-[#1e1e1e]"
                              : role === "Practitioner"
                              ? "bg-[#eaff6c] border-[#989898] text-[#0B4F9F]"
                              : "bg-[#e7edf5] border-[#989898] text-[#4b4b4b]"
                            : "bg-[#FDFFF0] border-[1px] rounded-[8px] border-[#A6B54D] text-[#A6B54D] hover:border-[#4b4b4b]"
                        }`}
                      >
                        <User className="w-3 h-3 lg:w-4 lg:h-4 inline mr-1 lg:mr-2" />
                        {role}
                      </button>
                    ))}
                  </div>
                </div>

                <p className="text-[12px] text-[#334155] font-poppins  lg:text-left">
                  Access dashboard & analytics
                </p>

                {/* Email Input */}
                <div>
                  {/* Show label only on desktop */}
                  <label className="hidden lg:block text-[12px] font-medium text-[#4B61FF] mb-2">
                    Organization Email ID
                  </label>
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <Mail className="h-5 w-5 text-[#94A3B8]" />
                    </div>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Email Id"
                      className={emailClassName}
                      onKeyDown={handleKeyDown}
                    />
                  </div>
                  <p className="text-[#DC2626] font-poppins text-[12px]">
                    {emailError}
                  </p>
                </div>

                {/* Send OTP Button */}
                <button
                  onClick={handleSendOTP}
                  className="w-full bg-[#0A66C2] hover:bg-[#0B4F9F] active:scale-[0.99] text-[#ffffff] text-[14px] font-semibold py-3 px-4 rounded-[12px] transition-all font-poppins h-[64px]"
                >
                  Send OTP
                </button>
              </div>
            ) : (
              <div className="space-y-4 lg:space-y-6">
                <h2 className="text-[16px] lg:text-[22px] font-poppins text-[#171717]  lg:text-left">
                  OTP Verification
                </h2>

                <p className="text-[14px] font-poppins text-[#334155]  lg:text-left">
                  OTP sent to <span className="text-[#4B61FF]">{email}</span>
                </p>

                {/* OTP Input */}
                <div className="flex justify-center gap-2 lg:gap-3">
                  {[0, 1, 2, 3, 4, 5].map((index) => (
                    <input
                      key={index}
                      id={`otp-${index}`}
                      type="password"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      value={otpCode[index]}
                      onChange={(e) => handleOtpChange(index, e.target.value)}
                      onKeyDown={(e) => handleOtpKeyDown(index, e)}
                      maxLength={1}
                      className="w-[54px] h-[54px] lg:w-[54px] lg:h-[54px] text-center text-lg lg:text-xl font-poppins border-[#4B61FF] bg-[#F8FAFC] rounded-[12px] focus:outline-none focus:ring-1 focus:ring-[#4B61FF] "
                      placeholder="0"
                    />
                  ))}
                </div>
                <p className="text-[#DC2626] font-poppins text-[12px]">
                  {otpError}
                </p>
                {/* Resend OTP and Timer */}
                <div className="flex justify-between items-center">
                  <button
                    onClick={() => setCountdown(90)}
                    className="text-[#4B61FF] hover:underline text-[12px] bg-transparent font-poppins"
                    disabled={countdown > 0}
                  >
                    Resend OTP?
                  </button>
                  <span className="text-red-500 text-[12px] font-medium font-poppins">
                    {Math.floor(countdown / 60)}:
                    {(countdown % 60).toString().padStart(2, "0")}
                  </span>
                </div>

                {/* Login Button */}
                <button
                  onClick={handleOTP}
                  className="w-full bg-[#0A66C2] hover:bg-[#0B4F9F] active:scale-[0.99] text-[#ffffff] text-[14px] font-semibold py-3 px-4 rounded-[12px] transition-all font-poppins h-[64px]"
                >
                  Login
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Bottom Footer Section */}
        <div className="mt-6 lg:mt-8">
          <div className="text-center mb-4">
            <p className="text-[12px] lg:text-[14px] text-[#334155] font-poppins">
              By logging in, you agree to our{" "}
              <a
                href="https://www.phyber.care/legal/privacy"
                target={"_blank"}
                className="text-[#4B61FF] font-semibold font-poppins no-underline hover:underline"
              >
                Privacy Policy
              </a>{" "}
              and{" "}
              <a
                href="https://www.phyber.care/legal/terms"
                target={"_blank"}
                className="text-[#4B61FF] no-underline hover:underline font-poppins font-semibold"
              >
                Terms of Use
              </a>
              .
            </p>
          </div>

          {/* Social Media Icons */}
          <div className="flex justify-center items-center space-x-4 w-full">
            {links.map((item) => {
              return (
                <a
                  href={item.link}
                  target={"_blank"}
                  className="text-[#0a66c2] hover:text-[#4B61FF]"
                >
                  <img src={item.image} />
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
